import React from 'react'
import { MenuOverlay, ListItem } from '@fs/zion-ui'
import type { UseOverlayReturnOptions } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import RelationshipViewerButton from '@fs/zion-relationship-viewer'
import Follow from '@fs/zion-follow'
import useFocusPerson from '../../../data-service/useFocusPerson'
import ToolsMenuItems from '../tools/ToolsMenuItems'

type MobileMenuProps = {
  overlay: UseOverlayReturnOptions
  showAdditionalActions?: boolean
}
export default function MobileMenu({ overlay, showAdditionalActions }: MobileMenuProps): JSX.Element | null {
  const [t] = useTranslation()
  const { focusPerson } = useFocusPerson()

  if (!focusPerson) return null

  return (
    <MenuOverlay {...overlay} inline={false} label="">
      {/* These items have to be wrapped individually instead of together in a fragment. See: https://fhjira.churchofjesuschrist.org/browse/ZIONUI-1044 */}
      {!focusPerson?.deleted && !focusPerson.readOnly && (
        <ListItem
          dense
          data-testid="mobile-research-help-link"
          linkName="Research Help Page"
          to={`/research-help/${focusPerson.id}`}
          primaryText={t('tree-person.research-help.label')}
        />
      )}
      {/* These items have to be wrapped individually instead of together in a fragment. See: https://fhjira.churchofjesuschrist.org/browse/ZIONUI-1044 */}
      {!focusPerson?.deleted && (
        <ListItem
          dense
          data-testid="mobile-search-records-link"
          linkName="Mobile Search Records"
          to={`/search-records/${focusPerson.id}`}
          primaryText={t('tree-person.search-records.label')}
        />
      )}
      <ListItem
        dense
        data-testid="mobile-changelog-link"
        linkName="Mobile Changelog"
        to={`/changelog/${focusPerson.id}`}
        primaryText={t('tree-person.changelog-summary.label')}
      />
      {showAdditionalActions && !focusPerson.researcherTree && (
        /* eslint-disable-next-line test-selectors/button -- NA */
        <RelationshipViewerButton
          toId={focusPerson.id}
          hideIcon
          asListItem
          listItemProps={{ dense: true }}
          disabled={focusPerson?.deleted}
        />
      )}
      {showAdditionalActions && !focusPerson?.deleted && !focusPerson.researcherTree && (
        <Follow as="ListItem" showText personObj={focusPerson} buttonProps={{ dense: true }} />
      )}
      {!focusPerson.deleted && <ToolsMenuItems hideIcons />}
    </MenuOverlay>
  )
}
